/* Componentes do Nebula reproduzidos em React.
 *
 * O projeto Claude Design entrega os componentes como web components num bundle
 * (`_ds_bundle.js`). Aqui eles são reescritos como componentes React pequenos,
 * estilizados só pelos tokens do Nebula (`nebula.css`), para viverem no mesmo
 * mundo de inline-styles do resto do painel. As specs (raio, cor, hover, peso)
 * vêm do `readme.md` do design system. Ícones são um subconjunto do Lucide
 * inlinado — sem CDN, para não depender de rede nem furar CSP. */

import React from 'react';

const GLIFOS = {
  'shield-check': ['M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z', 'm9 12 2 2 4-4'],
  plus: ['M5 12h14', 'M12 5v14'],
  filter: ['M22 3H2l8 9.46V19l4 2v-8.54L22 3z'],
  search: ['M21 21l-4.34-4.34', 'M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16z'],
  x: ['M18 6 6 18', 'm6 6 12 12'],
  'chevron-down': ['m6 9 6 6 6-6'],
  'building-2': ['M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z', 'M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2', 'M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2', 'M10 6h4', 'M10 10h4', 'M10 14h4', 'M10 18h4'],
  server: ['M4 2h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2z', 'M4 14h16a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2z', 'M6 6h.01', 'M6 18h.01'],
  smartphone: ['M5 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z', 'M12 18h.01'],
  activity: ['M22 12h-4l-3 9L9 3l-3 9H2'],
  database: ['M3 5c0-1.66 4-3 9-3s9 1.34 9 3-4 3-9 3-9-1.34-9-3z', 'M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5', 'M3 12c0 1.66 4 3 9 3s9-1.34 9-3'],
  cpu: ['M6 4h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z', 'M9 9h6v6H9z', 'M15 2v2', 'M15 20v2', 'M2 15h2', 'M2 9h2', 'M20 15h2', 'M20 9h2', 'M9 2v2', 'M9 20v2'],
  'circle-check': ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'm9 12 2 2 4-4'],
  'triangle-alert': ['M21.73 18 13.73 4a2 2 0 0 0-3.46 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3z', 'M12 9v4', 'M12 17h.01'],
  'key-round': ['M15.5 3a6.5 6.5 0 0 0-6.16 8.59L2.6 18.31A2 2 0 0 0 2 19.73V21a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 .7-.29l1.71-1.7A6.5 6.5 0 1 0 15.5 3z', 'M16.5 7.5h.01'],
  link: ['M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71', 'M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71'],
  'audio-lines': ['M2 10v4', 'M6 6v12', 'M10 3v18', 'M14 8v8', 'M18 5v14', 'M22 10v4'],
  'qr-code': ['M4 3h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z', 'M16 3h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z', 'M4 15h4a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1z', 'M15 15h2v2h-2z', 'M19 15h2v2h-2z', 'M15 19h2v2h-2z', 'M19 19h2v2h-2z'],
  'rotate-cw': ['M21 12a9 9 0 1 1-3.34-7', 'M21 3v6h-6'],
  calendar: ['M5 4h14a2 2 0 0 1 2 2v13a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z', 'M3 10h18', 'M8 2v4', 'M16 2v4'],
  megaphone: ['m3 11 18-5v12L3 14v-3z', 'M11.6 16.8a3 3 0 1 1-5.8-1.6'],
  clock: ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'M12 6v6l4 2'],
  users: ['M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2', 'M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8z', 'M22 21v-2a4 4 0 0 0-3-3.87', 'M16 3.13a4 4 0 0 1 0 7.75'],
  'message-square': ['M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z'],
  'layout-dashboard': ['M4 3h7v9H4z', 'M13 3h7v5h-7z', 'M13 12h7v9h-7z', 'M4 16h7v5H4z'],
  check: ['M20 6 9 17l-5-5'],
  send: ['M22 2 11 13', 'M22 2 15 22l-4-9-9-4z'],
  'check-check': ['M18 6 7 17l-5-5', 'm22 10-7.5 7.5L13 16'],
  'user-round': ['M12 13a5 5 0 1 0 0-10 5 5 0 0 0 0 10z', 'M20 21a8 8 0 0 0-16 0'],
  'corner-up-left': ['M9 14 4 9l5-5', 'M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5V20'],
  'circle-slash': ['M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20z', 'm5 5 14 14'],
  'log-out': ['M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4', 'm16 17 5-5-5-5', 'M21 12H9'],
};

export function Icon({ name, size = 16, style }) {
  const paths = GLIFOS[name] || [];
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      style={{ flex: 'none', display: 'block', ...style }}
    >
      {paths.map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  );
}

const TONS = {
  success: { bg: 'var(--success-soft)', cor: 'var(--success-text)', ponto: 'var(--success)' },
  warning: { bg: 'var(--warning-soft)', cor: 'var(--warning-text)', ponto: 'var(--warning)' },
  danger: { bg: 'var(--danger-soft)', cor: 'var(--danger-text)', ponto: 'var(--danger)' },
  info: { bg: 'var(--info-soft)', cor: 'var(--info-text)', ponto: 'var(--info)' },
  neutral: { bg: 'var(--surface-raised)', cor: 'var(--text-secondary)', ponto: 'var(--text-muted)' },
};

export function Tag({ tone = 'neutral', dot = false, children }) {
  const t = TONS[tone] || TONS.neutral;
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        height: 20,
        padding: '0 8px',
        borderRadius: 'var(--radius-pill)',
        background: t.bg,
        color: t.cor,
        font: 'var(--type-caption)',
        fontWeight: 'var(--fw-semibold)',
        whiteSpace: 'nowrap',
      }}
    >
      {dot && (
        <span style={{ width: 6, height: 6, borderRadius: '50%', background: t.ponto, flex: 'none' }} />
      )}
      {children}
    </span>
  );
}

const VARIANTES = {
  primary: { background: 'var(--accent)', color: 'var(--accent-on)', border: '1px solid transparent' },
  secondary: { background: 'var(--surface-raised)', color: 'var(--text-primary)', border: '1px solid var(--border-default)' },
  ghost: { background: 'transparent', color: 'var(--text-secondary)', border: '1px solid transparent' },
};

export function Button({ variant = 'secondary', icon, children, style, ...resto }) {
  const v = VARIANTES[variant] || VARIANTES.secondary;
  return (
    <button
      type="button"
      {...resto}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 8,
        height: 40,
        padding: '0 14px',
        borderRadius: 'var(--radius-control)',
        cursor: 'pointer',
        font: 'var(--type-body-strong)',
        fontWeight: 'var(--fw-semibold)',
        transition: 'background-color var(--dur-fast) var(--ease-standard), color var(--dur-fast) var(--ease-standard)',
        ...v,
        ...style,
      }}
    >
      {icon && <Icon name={icon} size={16} />}
      {children}
    </button>
  );
}

export function IconButton({ icon, label, onClick, style }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={label}
      title={label}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 36,
        height: 36,
        borderRadius: 'var(--radius-control)',
        background: 'transparent',
        color: 'var(--text-secondary)',
        border: '1px solid transparent',
        cursor: 'pointer',
        ...style,
      }}
    >
      <Icon name={icon} size={16} />
    </button>
  );
}

export function Select({ value, onChange, options, fullWidth = false }) {
  return (
    <span style={{ position: 'relative', display: 'inline-flex', width: fullWidth ? '100%' : 'auto' }}>
      <select
        value={value}
        onChange={onChange}
        style={{
          appearance: 'none',
          WebkitAppearance: 'none',
          width: '100%',
          height: 40,
          padding: '0 34px 0 12px',
          background: 'var(--surface-raised)',
          border: '1px solid var(--border-default)',
          borderRadius: 'var(--radius-control)',
          color: 'var(--text-primary)',
          font: 'var(--type-body)',
          fontSize: 'var(--fs-body-sm)',
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>
      <span style={{ position: 'absolute', right: 12, top: 0, bottom: 0, display: 'flex', alignItems: 'center', color: 'var(--text-muted)', pointerEvents: 'none' }}>
        <Icon name="chevron-down" size={16} />
      </span>
    </span>
  );
}

/** Cartão base do Nebula: superfície, hairline, raio de card, sombra baixa. */
export const card = {
  display: 'flex',
  flexDirection: 'column',
  minHeight: 0,
  flexShrink: 0, // em coluna flex com overflow, a seção rola — não encolhe
  background: 'var(--surface-card)',
  border: '1px solid var(--border-subtle)',
  borderRadius: 'var(--radius-card)',
  boxShadow: 'var(--shadow-sm)',
  overflow: 'hidden',
};

/** Título de página + descrição, repetido no topo de cada tela admin. */
export function Cabecalho({ titulo, descricao, acoes }) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 16, flex: '0 0 auto', padding: '22px 24px 16px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
        <h1 style={{ margin: 0, font: 'var(--type-h1)', letterSpacing: 'var(--ls-tight)' }}>{titulo}</h1>
        {descricao && <p style={{ margin: 0, font: 'var(--type-body)', fontSize: 'var(--fs-body-sm)', color: 'var(--text-muted)', maxWidth: '72ch' }}>{descricao}</p>}
      </div>
      {acoes && <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>{acoes}</div>}
    </div>
  );
}

/** Seção-cartão com título opcional. Rola por dentro se `rolar`. */
export function Secao({ titulo, acao, children, rolar = false, style }) {
  return (
    <section style={{ ...card, ...style }}>
      {(titulo || acao) && (
        <header style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12, flex: '0 0 auto', padding: '16px 20px 14px', borderBottom: '1px solid var(--border-subtle)' }}>
          {titulo && <h3 style={{ margin: 0, font: 'var(--type-title)', letterSpacing: 'var(--ls-snug)' }}>{titulo}</h3>}
          {acao}
        </header>
      )}
      <div style={rolar ? { flex: 1, minHeight: 0, overflow: 'auto' } : undefined}>{children}</div>
    </section>
  );
}

/** Aviso honesto de estado (carregando / vazio / erro), no tom do Nebula. */
export function Aviso({ titulo, texto, acao, aoAcao }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 8, minHeight: 220, padding: 32, textAlign: 'center' }}>
      <span style={{ font: 'var(--type-title)', color: 'var(--text-primary)' }}>{titulo}</span>
      {texto && <span style={{ font: 'var(--type-body)', fontSize: 'var(--fs-body-sm)', color: 'var(--text-muted)', maxWidth: 340 }}>{texto}</span>}
      {acao && <span style={{ marginTop: 6 }}><Button variant="secondary" onClick={aoAcao}>{acao}</Button></span>}
    </div>
  );
}

/** Nota discreta de rodapé — usada para marcar o que ainda é da Fase 0/4. */
export function Nota({ children }) {
  return (
    <p style={{ margin: '2px 24px 20px', font: 'var(--type-caption)', color: 'var(--text-placeholder)' }}>{children}</p>
  );
}
